<template>
  <div class="module-margin">
    <HeadNav></HeadNav>
    <div class="func-wrap">
      <van-skeleton :row="7" :loading="isSkeleton">
        <div v-for="item in list" :key="item.ID" class="module-info">
          <div class="module-title">{{ item.Name }}</div>
          <ul class="module-list">
            <li v-for="apps in item.applications"
              :key="apps.ID"
              @click="funcBtn(item, apps)"
              :class="apps.show ? 'module-apps' : ''"
            >
              <div class="module-apps-func" v-if="apps.show">
                <div>
                  <img v-if="apps.Icon.indexOf('png')>-1" :src="require('@/assets/moduleIcon/' + apps.Icon)" alt />
                  <img v-else :src="require('@/assets/moduleIcon/jwgl-kbcx-wdkb.png')" alt />
                </div>
                <div class="module-apps-names">{{ apps.Name }}</div>
              </div>
            </li>
          </ul>
        </div>
      </van-skeleton>
    </div>
  </div>
</template>
<script>
  import HeadNav from '@/pages/common/views/components/headnav/HeadNav.vue'
  export default {
    name: 'funclist',
    components: {
      HeadNav
    },
    data() {
      return {
        isSkeleton: true,
        list: [],
        domainList: []
      }
    },
    created() {
      this.getMobileMoudle()
    },
    methods: {
      async getMobileMoudle() {
        this.list = []
        this.domainList = []
        this.xy.loading()
        let res = await this.xyapi.get(this.xyMApi + '/xy/comm/MobileMoudle')
        this.xy.unloading()
        let resList = res.data.Modules
        //是否建营一体过来直接跳转对应的模块
        let toPath=this.$store.state.common.platformPath
        if(toPath){
          this.$store.commit('common/setPlatformPath', '')
          resList.map(item=>{
            item.applications.map(item1=>{
              if(item1.MobileUrl===toPath){
                localStorage.setItem("webSiteTitle", item1.Name)
                this.$store.commit('changeApiPath', `${this.xyMApi}/${item.ModuleCode}`)
                localStorage.setItem('breadcrumb', JSON.stringify(item1))
                if (item1.MobileUrl) {
                  localStorage.setItem('navTitle', item1.Name)
                  this.$router.replace(item1.MobileUrl)
                }
                this.$store.commit('common/getMenuIDs', [item1.MID, item1.ID])
              }
            })
          })
        }else{
          // 非ipad端不展示德育+活动菜单
          this.isIpadTerminal(resList)
          this.domainList = res.data.ServiceDomains
          for (let i = 0, len = resList.length; i < len; i++) {
            if (resList[i].Name !== '家校互通') {
              this.list.push(resList[i])
            }
          }
          this.changeIpadPath(this.list)
          this.isSkeleton = false
        }
      },
      changeIpadPath(list) {
        if (!window.isIpad || !list || !list.length) return
        let obj = list.find(i => i.Name === '智慧评价') || { applications: [] }
        obj = obj
          ? obj.applications.find(i => i.Name === '课堂评价') || { subMenu: [] }
          : { subMenu: [] }
        obj.subMenu = obj.subMenu.filter(item => {
          return item.ApplicationSubMenuMobileUrl !== '/home/evaStatistics'
        })
        obj.subMenu.forEach(item => {
          if (item.ApplicationSubMenuMobileUrl === '/home/evaStudentWrap') {
            item.ApplicationSubMenuMobileUrl = '/ipad/EvaStudentWrap'
          }
          if (item.ApplicationSubMenuMobileUrl === '/home/evaMyeva') {
            item.ApplicationSubMenuMobileUrl = '/ipad/evaMyeva'
          }
        })
      },
      // isIpadTerminal(list) {
      //   if (!window.isIpad) {
      //     console.log(list)
      //     list.map((item,index) => {
      //       item.applications.map(i => (i.Name !== '活动课程评价' && i.Name !== '德育一日评价') ? i.show = true : i.show = false)
      //     })
      //   }else {
      //     list.map((item, index) => {
      //       item.applications.map(i => (i.Name !== '') ? i.show = true : i.show = false)
      //     })
      //   }
      // },
       isIpadTerminal(list) {
        if (!window.isIpad) {
          console.log(list)
          list.map((item) => {
            item.applications.map(i => (i.Name !== '活动课程评价' && i.Name !== '德育一日评价') ? i.show = true : i.show = true)
          })
        }else {
          list.map((item) => {
            item.applications.map(i => (i.Name !== '') ? i.show = true : i.show = false)
          })
        }
      },
      funcBtn(pval, vals) {
        if (vals.MobileUrl.indexOf('http://') > -1 ||vals.MobileUrl.indexOf('https://') > -1) {
          if (vals.IsExternal) {
              let urls = `${vals.MobileUrl}${vals.MobileUrl.indexOf('?') > -1 ? '&' : '?'}`
              let tokens = this.xy.getCookie(".XYTOKEN")
              let actumber =  window.localStorage.getItem("AccountNumber");
              window.open(`${urls}token=${tokens}&AccountNumber=${actumber}`)
              return
            }
        }else{
          this.$store.commit('changeApiPath', `${this.xyMApi}/${pval.ModuleCode}`)
          localStorage.setItem('breadcrumb', JSON.stringify(vals))
          if (vals.MobileUrl) {
            localStorage.setItem('navTitle', vals.Name)
            this.$router.push(vals.MobileUrl)
          } else {
            localStorage.setItem('navTitle', vals.subMenu[0].Name)
            this.$router.push(vals.subMenu[0].ApplicationSubMenuMobileUrl)
          }
          this.$store.commit('common/getMenuIDs', [vals.MID, vals.ID])
          this.$store.commit('evaluation/changePjgetMenuIDs', [vals.subMenu[0].ApplicationID,vals.subMenu[0].ID])
        }
      }
    }
  }
</script>
<style lang="less" scoped>
  .module-margin {
    .func-wrap {
      margin-top: 100px;
    }
    .module-info {
      margin: 20px;
      padding: 20px;
      background: #ffffff;
      .module-list {
        display: flex;
        flex-wrap: wrap;
      }
      .module-title {
        border-left: 8px solid #4196ff;
        padding-left: 10px;
        font-weight: bold;
        font-size: 28px;
        margin-bottom: 40px;
      }

      .module-apps {
        // margin: 30px 0 0 20px;
        width: 25%;
        margin-bottom: 40px;
        .module-apps-func {
          font-size: 26px;
          // display: flex;
          // align-items: center;
          text-align: center;
          div {
            // width: 80px;
            // text-align: left;
            img {
              width: 60px;
            }
          }
          .module-apps-names {
            margin-top: 10px;
          }
        }
      }
    }
  }
</style>
